import "../../../assets/RideSelectOld.css";
import o, { forwardRef as Ee, useState as c, useRef as E, useImperativeHandle as Oe, useEffect as O, cloneElement as we } from "react";
import M from "clsx";
import { RideGlDown as Ce } from "../graphic/glyph/components/RideGlDown.js";
import { RideGlError as Se } from "../graphic/glyph/components/RideGlError.js";
import { RideMenuOption as Ne } from "./menu-option/RideMenuOption.js";
import { RideErrorMessage as ke } from "../error-message/RideErrorMessage.js";
import xe from "lodash.uniqueid";
import { setNativeValue as Re } from "../../../utils/events.js";
const De = "_label_oy74s_60", Le = "_optional_oy74s_71", Me = "_active_oy74s_126", Pe = "_combobox_oy74s_142", Be = "_disabled_oy74s_145", He = "_graphic_oy74s_169", Ie = "_divider_oy74s_172", ze = "_error_oy74s_175", Ge = "_hidden_oy74s_238", Te = "_medium_oy74s_249", Ue = "_bottom_oy74s_262", Ae = "_top_oy74s_265", Ke = "_large_oy74s_268", $e = "_rotate_oy74s_1", qe = "_loading_oy74s_1", n = {
  "ride-select": "_ride-select_oy74s_54",
  label: De,
  optional: Le,
  "select-container": "_select-container_oy74s_79",
  "input-hidden": "_input-hidden_oy74s_97",
  "select-text": "_select-text_oy74s_100",
  active: Me,
  "glyph-arrow-container": "_glyph-arrow-container_oy74s_126",
  combobox: Pe,
  disabled: Be,
  "glyph-close-container": "_glyph-close-container_oy74s_162",
  "helper-text": "_helper-text_oy74s_166",
  graphic: He,
  divider: Ie,
  error: ze,
  "menu-option": "_menu-option_oy74s_230",
  "fade-in": "_fade-in_oy74s_1",
  hidden: Ge,
  medium: Te,
  "input-text": "_input-text_oy74s_254",
  bottom: Ue,
  top: Ae,
  large: Ke,
  "fade-out": "_fade-out_oy74s_1",
  rotate: $e,
  loading: qe,
  "slide-in-up": "_slide-in-up_oy74s_1",
  "slide-in-down": "_slide-in-down_oy74s_1",
  "fill-center-out": "_fill-center-out_oy74s_1"
}, je = Ee(
  ({
    "aria-required": P,
    id: V,
    className: W,
    combobox: i,
    defaultValue: _,
    disabled: a,
    error: B,
    errorMessage: H,
    helperText: I,
    watchFieldRHF: w,
    label: z,
    loading: G,
    onBlur: T,
    onClick: C,
    onInput: X,
    onKeyDown: S,
    onOpenChange: N,
    onSelect: k,
    options: d = [
      {
        label: "",
        value: ""
      }
    ],
    required: U,
    size: Y = "medium",
    value: f,
    "aria-label": Z,
    "data-testid": F,
    informativePopover: A,
    ...ee
  }, te) => {
    const K = {
      label: "",
      value: ""
    }, [s, $] = c(K), [l, x] = c(!1), [ne, oe] = c("bottom"), [g] = c(V ?? xe(":ride:")), q = E(null), h = E(null), u = E(null), y = E(null), [R, p] = c({
      label: "",
      graphic: null
    }), [re, v] = c(d);
    Oe(te, () => y.current), O(() => {
      N == null || N(l);
    }, [l]), O(() => {
      if (s.value) {
        const e = j(
          s.value.toString()
        );
        v(e);
      } else
        v(d);
    }, [d]);
    const j = (e) => d.map((t) => ({
      ...t,
      checked: t.value.toString() === e
    })), m = (e) => {
      const t = j(e), r = t.find((Q) => Q.checked) || K;
      return v(t), $(r), r;
    };
    O(() => {
      if (!y.current) return;
      let t = m("");
      w !== void 0 ? t = m(w.toString()) : f ? t = m(f.toString()) : _ && (t = m(_.toString())), t && D(t.value.toString()), p({ label: t.label, graphic: t.graphic });
    }, [w, _, f]);
    const D = (e) => {
      const t = y.current;
      if (!t) return;
      const r = new Event("input", { bubbles: !0 });
      Re(t, e), t == null || t.dispatchEvent(r);
    }, J = (e) => {
      const t = u.current;
      !t || t.contains(e.target) || (p({
        label: s.label,
        graphic: s.graphic
      }), L());
    };
    O(() => (document.addEventListener("mousedown", (e) => J(e)), () => {
      document.removeEventListener("mousedown", J);
    }), [s]);
    const b = () => {
      const e = h.current;
      if (!e) return;
      e.classList.contains(n.active) || se(e), e.classList.toggle(n.active), x((r) => !r);
    }, ie = (e) => {
      C && typeof C == "function" && C(e);
    }, se = (e) => {
      const t = q.current;
      if (!t) return;
      const r = t == null ? void 0 : t.getHeight(), be = window.innerHeight - e.getBoundingClientRect().bottom > r + 8 ? "bottom" : "top";
      oe(be);
    }, L = () => {
      const e = h.current;
      e && (e.classList.remove(n.active), x(!1));
    }, le = (e) => {
      e.stopPropagation();
      const t = e.target.value, r = m(t);
      k && typeof k == "function" && k(r), p({ label: r.label, graphic: r.graphic }), D(r.value), L();
    }, ce = () => {
      if (!a && B && H)
        return /* @__PURE__ */ o.createElement(ke, { message: H });
      if (I)
        return /* @__PURE__ */ o.createElement("p", { className: n["helper-text"] }, I);
    }, ae = (e) => {
      x(!0), p({ label: e.target.value, graphic: null });
    }, de = () => {
      p({ label: "", graphic: null }), $({
        label: "",
        value: ""
      });
      const e = d.map((t) => ({
        ...t,
        checked: !1
      }));
      v(e), D("");
    }, ue = (e) => {
      e.code === "Space" && !i && b(), e.code === "Enter" && b(), S && typeof S == "function" && S(e);
    }, pe = (e) => {
      e.code === "Space" && L();
    }, me = () => {
      l && i && b();
    }, _e = () => M(W, n["ride-select"], n[Y], {
      [n.disabled]: a,
      [n.error]: !a && B,
      [n.combobox]: i
    }), fe = () => M(n["menu-option"], n[ne], {
      [n.hidden]: !l
    }), ge = () => M(n["select-text"]), he = () => {
      var e;
      (e = h.current) == null || e.focus(), !(l && i) && b();
    }, ye = (e) => {
      setTimeout(() => {
        var t;
        (t = u == null ? void 0 : u.current) != null && t.contains(document.activeElement) ? e.target.focus() : typeof T == "function" && T(e);
      }, 100);
    }, ve = () => A ? we(A, { size: "small" }) : null;
    return /* @__PURE__ */ o.createElement(
      "div",
      {
        "data-testid": F,
        className: _e(),
        ref: u
      },
      z && /* @__PURE__ */ o.createElement("label", { className: n.label, htmlFor: g }, z, !(U || P) && /* @__PURE__ */ o.createElement("span", { className: n.optional }, "(opcional)"), ve()),
      /* @__PURE__ */ o.createElement(
        "div",
        {
          className: n["select-container"],
          onKeyDown: pe,
          onClick: he
        },
        R.graphic && /* @__PURE__ */ o.createElement("div", { className: n.graphic }, R.graphic),
        /* @__PURE__ */ o.createElement(
          "input",
          {
            ...ee,
            className: n["input-hidden"],
            value: f,
            defaultValue: _,
            type: "text",
            readOnly: !0,
            ref: y,
            required: U
          }
        ),
        /* @__PURE__ */ o.createElement(
          "input",
          {
            "aria-busy": !a && G ? "true" : "false",
            "aria-controls": `${g}:select-dropdown`,
            "aria-expanded": l ? "true" : "false",
            "aria-label": Z,
            "aria-required": P,
            autoComplete: "off",
            className: ge(),
            disabled: a,
            id: g,
            onBlur: ye,
            onChange: ae,
            onClick: ie,
            onKeyDown: ue,
            onInput: X,
            placeholder: "Elige una opción",
            ref: h,
            role: "combobox",
            readOnly: !i,
            type: "text",
            value: R.label
          }
        ),
        i && s.label && /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
          "button",
          {
            className: n["glyph-close-container"],
            onClick: de,
            type: "button"
          },
          /* @__PURE__ */ o.createElement(Se, { size: "large", fill: "currentColor" })
        ), /* @__PURE__ */ o.createElement("div", { className: n.divider })),
        /* @__PURE__ */ o.createElement(
          "div",
          {
            className: n["glyph-arrow-container"],
            onClick: me
          },
          /* @__PURE__ */ o.createElement(Ce, { size: "large", fill: "currentColor" })
        ),
        /* @__PURE__ */ o.createElement("div", { className: fe() }, /* @__PURE__ */ o.createElement(
          Ne,
          {
            id: `${g}:select-dropdown`,
            options: re,
            onClick: (e) => le(e),
            showMaxOptions: 5,
            ref: q,
            messageEmptyOptions: i ? "Sin resultados" : "Sin opciones",
            loading: G
          }
        ))
      ),
      ce()
    );
  }
);
je.displayName = "RideSelectOld";
export {
  je as RideSelectOld
};
